import Row from './row';
import Col from './col';
export { Row, Col };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/grid/index.js
// module id = 149
// module chunks = 3